import styled from 'styled-components';

export const QuestionsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const QuestionItem = styled.button`
	display: grid;
	grid-template-areas:
		'QuestionText  QuestionBtn'
		'QuestionDescription . ';
	grid-template-columns: 1fr 28px;

	padding: 28px 24px;
	background: #ffffff;
	border: 1px solid #d9dae5;
	box-sizing: border-box;
	border-radius: 4px;

	width: 55vw;
	margin-bottom: 16px;
	cursor: pointer;
	text-align: left;
	-webkit-appearance: none !important;

	@media (max-width: 600px) {
		width: 100%;
		padding: 16px 12px;
	}
`;

export const QuestionText = styled.div`
	grid-area: QuestionText;

	${({ theme }) => theme.typography.textMediumL};

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textMediumM};
	}
`;

export const QuestionDescription = styled.div`
	grid-area: QuestionDescription;

	${({ theme }) => theme.typography.textMediumS};

	padding: ${({ isActive }) => (isActive ? '25px 40px 25px 0' : '0 40px 0 0')};
	height: ${({ isActive }) => (isActive ? 'fit-content' : 0)};
	opacity: ${({ isActive }) => (isActive ? 1 : 0)};
	transition-property: opacity, padding;
	transition-duration: 0.3s, 0.3s;

	@media (max-width: 600px) {
		padding: ${({ isActive }) => (isActive ? '15px 0' : '0')};
		${({ theme }) => theme.typography.textS};
	}
`;

export const DropDownElem = styled.div`
	grid-area: QuestionBtn;

	@media (max-width: 600px) {
		justify-self: center;
	}
`;

export const DropDownIcon = styled.svg`
	width: 16px;
	height: 16px;
	transition: transform 0.3s ease;
	${(props) => props.reverse && 'transform: rotate(180deg);'}
`;
